/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {FolderShareProps} from './FolderShared';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) FolderSharedOpened Icon component.
 */
export const FolderSharedOpened = ({color, size, folderColor, ...props}: FolderShareProps) => {
  const {iconSize = 24, iconColor = dlsColor('grey1')} = useIconDLS({color, size});
  return (
    <ThemeIconProvider name='FolderSharedOpened' size={size} color={color} folderColor={folderColor} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        {folderColor && (<rect x='0' y='8' width='4' height='11.5' fill={folderColor} rx='1' ry='1'/>)}
        <path clipRule='evenodd' d='M20.5 8c-.189 0-.37-.035-.536-.098l-2.46 1.757 2.198 1.57a1.5 1.5 0 1 1-.622.785l-2.34-1.671A1.499 1.499 0 0 1 14 9.5a1.5 1.5 0 0 1 2.868-.616l2.32-1.657A1.5 1.5 0 1 1 20.5 8zM8.172 9a1 1 0 0 1 .707.293L10.586 11h2.41v-1H11L9 8H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h11.528a2 2 0 0 0 1.79-1.106l1-2A2 2 0 0 0 17.527 14h-3.764l-2-2H8a2 2 0 0 0-1.788 1.106l-2 4a1.992 1.992 0 0 0-.212.892V10a1 1 0 0 1 1-1h3.172zm-1.066 4.553A1 1 0 0 1 8 13h3.35l2 2h4.178a.999.999 0 0 1 .895 1.447l-1 2a1 1 0 0 1-.895.553H6a1 1 0 0 1-.894-1.447l2-4z' fill={iconColor} />
      </svg>
    )} />
  );
};

export default FolderSharedOpened;
